// (B) 플레인 InputNumber — antd InputNumber 대체(순수 시각). antd DOM 미러링:
// .om-input-number > .om-input-number-handler-wrap(up/down) / .om-input-number-input-wrap > input.om-input-number-input.
// 소비처 SCSS(.om-input-number*)가 시각 정의 → 여기선 구조+antd base(styles/omInputNumber.css)만.
import type { OmwInputNumberProps } from '../api/OmwInputNumber'
import { cx } from './cx'
import '../styles/omwInputNumber.css'

const STEP = 1

export function PlainInputNumber({
  value,
  onChange,
  min,
  max,
  placeholder,
  disabled,
  className,
  style,
}: OmwInputNumberProps) {
  const clamp = (next: number): number => {
    let result = next
    if (min != null && result < min) result = min
    if (max != null && result > max) result = max
    return result
  }

  const step = (dir: 1 | -1) => {
    if (disabled) return
    const base = typeof value === 'number' ? value : (min ?? 0)
    onChange?.(clamp(base + dir * STEP))
  }

  const handleInput = (raw: string) => {
    if (raw === '') {
      onChange?.(null)
      return
    }
    const parsed = Number(raw)
    if (Number.isNaN(parsed)) return
    onChange?.(clamp(parsed))
  }

  const upDisabled = disabled || (max != null && typeof value === 'number' && value >= max)
  const downDisabled = disabled || (min != null && typeof value === 'number' && value <= min)

  return (
    <div
      className={cx('om-input-number', disabled && 'om-input-number-disabled', className)}
      style={style}
    >
      <div className="om-input-number-handler-wrap">
        <span
          className={cx(
            'om-input-number-handler',
            'om-input-number-handler-up',
            upDisabled && 'om-input-number-handler-up-disabled',
          )}
          role="button"
          aria-label="Increase Value"
          onClick={() => step(1)}
        >
          <span className="om-input-number-handler-up-inner">▲</span>
        </span>
        <span
          className={cx(
            'om-input-number-handler',
            'om-input-number-handler-down',
            downDisabled && 'om-input-number-handler-down-disabled',
          )}
          role="button"
          aria-label="Decrease Value"
          onClick={() => step(-1)}
        >
          <span className="om-input-number-handler-down-inner">▼</span>
        </span>
      </div>
      <div className="om-input-number-input-wrap">
        <input
          className="om-input-number-input"
          type="number"
          value={value ?? ''}
          min={min}
          max={max}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(e) => handleInput(e.target.value)}
        />
      </div>
    </div>
  )
}
